<template>
  <div id="app">
    <Navbar :user="user" @showLoginModal="onShowLoginModal" @logout="onLogout"/>
    <AddFlashcardModal :showAddFlashcardModal="showAddFlashcardModal" @cancelAddNewFlashcardModal="onCancelAddNewFlashcardModal" @saveAddNewFlashcardModal="onSaveAddNewFlashcardModal"/>
    <EditFlashcardModal 
      :showEditFlashcardModal="showEditFlashcardModal" 
      :cardEditing="cardEditing"
      @cancelEditFlashcardModal="onCancelEditFlashcardModal" 
      @saveEditFlashcardModal="onSaveEditFlashcardModal"
    />
    <ListCollectionModal :showListCollectionModal="showListCollectionModal" @cancelListCollectionModal="onCancelListCollectionModal" 
      @deleteCollection="onDeleteCollection"  
      @saveAddCollection="onSaveAddCollectionModal"
      @switchCollection="onSwitchCollection"
      @updateCollectionName="onUpdateCollectionName"
      :collections="collections"
      
    />
    <button v-if="!!user.uid" type="button" class="btn btn-primary btn-lg btn-block rounded-0" @click="onShowListCollectionModal">
      {{currentCollName}}
    </button>

    <LoginModal :showLoginModal="showLoginModal" @cancelLoginModal="onCancelLoginModal" @submitLoginModal="onSubmitLoginModal"/>
    <!-- <CollectionPicker :user="user" :collections="collections" @switchCollection="onSwitchCollection" @createCollection="onCreateCollection" :currentCollName="currentCollName" /> -->
    <CardsContainer 
      :cards="cards" 
      :currentCollId="currentCollId" 
      @newCard="onShowAddFlashcardModal" 
      @delCard="onDelCard" 
      @editCard="onShowEditFlashcardModal" 
    />
    <LoadingScreen :isNetworkLoading="isNetworkLoading" />
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import CardsContainer from './components/CardsContainer.vue'
import ListCollectionModal from "./components/ListCollectionModal.vue"
import AddFlashcardModal from './components/AddFlashcardModal.vue'
import EditFlashcardModal from "./components/EditFlashcardModal.vue"
import LoginModal from './components/LoginModal.vue'
import CardUtils from "./CardUtils.js"
import Api from "./Api.js"
import LoadingScreen from "./components/LoadingScreen.vue"
import {store} from "./store.js"

// import Vue from 'vue'
import axios from 'axios'

function saveUserIdentity(user, jwt) {
  window.localStorage.setItem('uid', user.userId)
  window.localStorage.setItem('username', user.username)
  window.localStorage.setItem('jwt', jwt)
}

function clearUserIdentity(){
    window.localStorage.removeItem('uid')
    window.localStorage.removeItem('username')
    window.localStorage.removeItem('jwt')
}

export default {
  name: 'App',
  // props: ['user'],
  data: function(){
    return {
      user: {
        uid: null,
        username: "Guest",
        jwt: null
      },
      userLoginCount: 0,
      cards_: {},
      collections: [],
      currentCollId: "",
      showAddCollectionModal: false,
      showAddFlashcardModal: false,
      showLoginModal: false,
      showEditFlashcardModal: false,
      showListCollectionModal: false,
      hostname: process.env.VUE_APP_HOSTNAME,
      authHostname: process.env.VUE_APP_AUTH_HOSTNAME,
      appApiVersion: process.env.VUE_APP_API_VERSION,
      authApiVersion: process.env.VUE_APP_AUTH_API_VERSION,
      cardEditing: null,
      networkQueue: {}
    }
  },
  computed: {
    isNetworkLoading: function(){
      return Object.keys(this.networkQueue).length > 0
    },
    uidForWatch: function(){
      return this.user.uid
    },
    jwtForWatch: function(){
      return this.user.jwt
    },
    cards: function(){
      if (!this.currentCollId || !this.currentCollId.length ) return []

      var c = this.cards_[this.currentCollId] || []
      var x = CardUtils.generateCards(c)

      return x
      // var sorted = [...c].sort((a, b) => {
      //   if (a.cardId < b.cardId) return -1
      //   if (a.cardId > b.cardId) return 1
      //   if (a.cardType < b.cardType) return 1
      //   if (a.cardType > b.cardType) return -1
      //   return 0
      // })
      // return sorted
    },
    currentCollName: function(){
      if (this.collections.length == 0) return "Select a collection"

      var coll
      for (coll of this.collections){
        if (coll.collId == this.currentCollId) break
      }
      return coll.collName
    }
  },
  methods: {
    onSwitchCollection: async function(collId){
      var conn = Api.ConnectionManager.newConnection(Api.API.getCardsInCollection(collId))
      var res = await conn.do()

      this.$set(this.cards_, collId, res.data)

      this.currentCollId = collId
    },
    onCreateCollection: function(){
      this.showAddCollectionModal = true
    },
    onCancelAddCollectionModal: function(){
      this.showAddCollectionModal = false
    },
    onSaveAddCollectionModal: async function(){

      var newCollectionName = prompt("New Collection Name:", "New Collection")
      if (!newCollectionName) {
        return 
      }

      var res
      try {
        var conn = Api.ConnectionManager.newConnection(Api.API.createNewCollection(JSON.stringify({
          collName: newCollectionName
        })))
        res = await conn.do()
      } catch (e){
        return alert("Error creating new collection")
      }

      if (res.data) {
        var collId = res.data.collId.toString()
        this.collections.push(res.data)
        this.$set(this.cards_, collId, [])
        this.currentCollId = collId
      }

      this.showAddCollectionModal = false

    },
    onShowAddFlashcardModal: function(){
      this.showAddFlashcardModal = true
    },
    onShowEditFlashcardModal: function(currentCard){
      this.showEditFlashcardModal = true
      this.cardEditing = currentCard
    },
    onCancelEditFlashcardModal: function(){
      this.showEditFlashcardModal = false
      this.cardEditing = null
    },
    onSaveEditFlashcardModal: async function(updated){
      try {
        var conn
        var res
        // Q and A need to be submitted in 2 separate requests
        if (updated.question != this.cardEditing.question.body ||
            updated.questionUsesMarkdown != this.cardEditing.question.usesMarkdown){
          conn = Api.ConnectionManager.newConnection(Api.API.updateFlashcard(JSON.stringify({
            collId: this.currentCollId,
            cardId: this.cardEditing.meta.cardId,
            cardComponent: this.cardEditing.question.cardComponent,
            cardBody: updated.question,
            usesMarkdown: updated.questionUsesMarkdown
          })))
          res = await conn.do()
          this.cardEditing.question.body = res.data.updatedBody
          this.cardEditing.question.rawBody = res.data.updatedRawBody
          this.cardEditing.question.usesMarkdown = res.data.usesMarkdown
        }
        if (updated.answer != this.cardEditing.answer.body ||
            updated.answerUsesMarkdown != this.cardEditing.answer.usesMarkdown){
          conn = Api.ConnectionManager.newConnection(Api.API.updateFlashcard(JSON.stringify({
            collId: this.currentCollId,
            cardId: this.cardEditing.meta.cardId,
            cardComponent: this.cardEditing.answer.cardComponent,
            cardBody: updated.answer,
            usesMarkdown: updated.answerUsesMarkdown
          })))
          res = await conn.do()
          this.cardEditing.answer.body = res.data.updatedBody
          this.cardEditing.answer.rawBody = res.data.updatedRawBody
          this.cardEditing.answer.usesMarkdown = res.data.usesMarkdown
        }

        
      } catch (e){
        console.log(e)
        alert("Error saving changes")
      }
      this.cardEditing = null
      this.showEditFlashcardModal = false
    },
    onCancelAddNewFlashcardModal: function(){
      this.showAddFlashcardModal = false
      store.lastSeenCardNum = null
    },
    onSaveAddNewFlashcardModal: async function(cardData){
      var conn = Api.ConnectionManager.newConnection(Api.API.addNewFlashcard(JSON.stringify({
        question: cardData.question,
        answer: cardData.answer,
        collId: this.currentCollId,
        questionUsesMarkdown: cardData.questionUsesMarkdown,
        answerUsesMarkdown: cardData.answerUsesMarkdown
      })))
      var res = await conn.do()

      if (res.data) {

        this.cards_[this.currentCollId] = this.cards_[this.currentCollId].concat(res.data)
        // var currentCards = this.cards_[this.currentCollId]
        // var x = [].concat(currentCards, res.data)
        // this.$set(this.cards_, this.currentCollId, x)
      }

      this.showAddFlashcardModal = false
    },
    onShowLoginModal: function(){
      this.showLoginModal = true
    },
    onCancelLoginModal: function(){
      this.showLoginModal = false
    },
    onSubmitLoginModal: async function(formData){
      try {
        var conn = Api.ConnectionManager.newConnection(Api.API.login(JSON.stringify({
          username: formData.username,
          password: formData.password
        })))
        var res = await conn.do()

        if (res.data) {
          var user = res.data.user
          saveUserIdentity(user, res.data.jwt)
          this.$set(this.user, "jwt", res.data.jwt)
          this.$set(this.user, "uid", user.userId)
          this.$set(this.user, "username", user.username)
          this.$nextTick(function(){
            this.userLoginCount += 1
          })
        }

        this.showLoginModal = false
      } catch (e) {
        alert("Error logging in")
      }
    },
    onLogout: async function(){
      var conn = Api.ConnectionManager.newConnection(Api.API.logout(), 0)
      try {
        await conn.do()
      } catch (e) {
        // will clean up the localstorage nonetheless
        console.log(e)
      }     

      clearUserIdentity()

      this.$set(this.user, "uid", null)
      this.$set(this.user, "username", window.localStorage.getItem('username'))
      this.$set(this.user, "jwt", null)

      this.cards_ = {}
      this.collections = []
      this.currentCollId = ""
    },
    onDelCard: async function (c){
      if (confirm("Delete this card?")){
        var cardId = c.meta.cardId
        try {
          var conn = Api.ConnectionManager.newConnection(Api.API.deleteFlashcard(JSON.stringify({
              cardId: cardId,
              collId: this.currentCollId
            })))
          await conn.do()

          var cards = this.cards_[this.currentCollId]
          for (var i = cards.length - 1; i >= 0; i --){
            if (cards[i].cardId == cardId) {
              cards.splice(i, 1)
            }
          }
        } catch (e){
          console.log(e)
          alert("Failed to delete flashcard")
        }
      }else {
        store.lastSeenCardNum = null
      }
    },
    onShowListCollectionModal: function(){
      this.showListCollectionModal = true
    },
    onCancelListCollectionModal: function(){
      this.showListCollectionModal = false
    },
    onUpdateCollectionName: async function(collId, collName){
      var newCollName = window.prompt("Update Collection Name to:", collName)
      if (!newCollName || newCollName == collName) return
      
      try {
        var conn = Api.ConnectionManager.newConnection(Api.API.updateCollection(JSON.stringify({
          collId: collId,
          collName: newCollName
        })))
        await conn.do()

        var coll
        for (coll of this.collections){
          if (coll.collId == collId) break
        }

        coll.collName = newCollName
      } catch (e){
        console.log(e)
        alert("Failed to update the collection name")
      }

    },
    onDeleteCollection: async function(collId){
      var confirm = window.confirm("Confirm to delete this collection?")
      if (!confirm) return

      try {
        var conn = Api.ConnectionManager.newConnection(Api.API.deleteCollection(JSON.stringify({collId: collId})))
        await conn.do()

        // Swap with the first in collection if current collection is the one to be deleted
        if (this.currentCollId == collId) {
          for (var i = 0; i < this.collections.length; i ++){
            if (this.collections[i].collId != collId){
              this.currentCollId = collId
            }
          }
          if (this.currentCollId == collId) {
            this.currentCollId = ""
          }
        }

        // Safely delete from local data
        this.$delete(this.cards_, collId)

        for (var j = this.collections.length - 1; j >= 0; j --){
          if (this.collections[j].collId == collId) {
            this.collections.splice(j, 1)
          }
        }
      } catch (e){
        console.log(e)
        alert("Failed to delete the collection")
      }
    }
  },
  components: {
    CardsContainer,
    Navbar,
    AddFlashcardModal,
    EditFlashcardModal,
    LoginModal,
    ListCollectionModal,
    LoadingScreen
  },
  created() {
    this.$set(this.user, "uid", window.localStorage.getItem('uid'))
    this.$set(this.user, "username", window.localStorage.getItem('username'))
    this.$set(this.user, "jwt", window.localStorage.getItem('jwt'))

    if (window.localStorage.getItem("jwt")) {
      axios.defaults.headers.common['authorizationToken'] = window.localStorage.getItem("jwt")
      this.$nextTick(function(){
        this.userLoginCount += 1
      })
    }

    Api.ConnectionManager.getEventBus().$on("newConnection", (taskId) => {
      this.$set(this.networkQueue, taskId, true)
    })
    Api.ConnectionManager.getEventBus().$on("closeConnection", (taskId) => {
      this.$delete(this.networkQueue, taskId)
    })
  },
  async mounted () {

  },
  watch: {
    userLoginCount: async function (newUid){
      if (!newUid) return

      var conn = Api.ConnectionManager.newConnection(Api.API.getAllCollections())
      var res = await conn.do()

      if (res.data.length > 0) {
        this.collections = res.data
        var collId = res.data[0].collId.toString()
        this.currentCollId = collId
        
        conn = Api.ConnectionManager.newConnection(Api.API.getCardsInCollection(collId))
        res = await conn.do()

        this.$nextTick(function(){
            this.$set(this.cards_, collId, res.data)
        })

      }

    },
    jwtForWatch: function(newJwt) {
      if (!newJwt) {
        delete axios.defaults.headers.common['authorizationToken']
        return
      }
      axios.defaults.headers.common['authorizationToken'] = newJwt
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

</style>
